import React, { useEffect, useState } from "react";
import ItemUsedTable, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
  ImageCell,
  ProductCell,
} from "./ItemUsedTable"; // new
import { Link } from "react-router-dom";

function ItemsUsedData() {
  const data = [
    {
      id: "1",
      number: "123-xyz",
      item: "Same Product",
      available: "Yes",
    },
    {
      id: "2",
      number: "123-xyz",
      item: "Same Product",
      available: "Yes",
    },
    {
      id: "3",
      number: "123-xyz",
      item: "Same Product",
      available: "No",
    },
    {
      id: "3",
      number: "123-xyz",
      item: "Same Product",
      available: "Yes",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Number",
        accessor: "number",
      },

      {
        Header: "Item Name",
        accessor: "item",
      },

      {
        Header: "Available",
        accessor: "available",
        Cell: StatusPill,
      },
      {
        Header: "Item Image",
        accessor: "image",
        Cell:ImageCell,
      },

      {
        Header: "Actions",
        accessor: "action",
        Cell: (value) => (
          <button
          type="button"
          class="bg-blue-200 text-white border-2 border-blue-200 font-Montserrat  hover:bg-blue-50 hover:text-blue-200  focus:outline-none  font-medium rounded-sm text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
        >
          Open
        </button>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <ItemUsedTable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default ItemsUsedData;
